import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import {OrderStatusPageContext} from "@MasterBluePrint/Overrides/Pages/OrderStatusPage";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import React, { FC, useContext } from "react";
import { css } from "styled-components";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";

export interface OrderDateStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    orderDate?: TypographyProps;
}
const mapStateToProps = (state: ApplicationState) => ({
    orderData: state.pages.orderStatus.order,
});
type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export const orderDateStyles: OrderDateStyles = {
    wrapper: {
        css: css`
            padding-bottom: 0.625rem;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: ${themeFontSizes.size18};
            }
            margin-bottom: 0.3125rem;
            margin-right: 0.3125rem;
            font-size: ${themeFontSizes.size18};
            display: inline-block;
            color: ${themeColors.colorPrimary};
            font-weight: ${themeFontWeights.fontWeightBold};
            font-family: 'Roboto', sans-serif;
            &:after {
                content: ':';
                display: inline-block;
            }
        `,
    },
    orderDate: {
        css: css`
        margin-top: 4px !important;
        margin-bottom: 0.3125rem;
        margin-right: 0.3125rem;
        font-size: ${themeFontSizes.size18};
        display: inline-block;
        color: ${themeColors.colorCharcoalGrey};
        font-family: 'Roboto', sans-serif;
    `,
    },
};

const styles = orderDateStyles;

const OrderDate: FC<Props> = ({ orderData }) => {
     const { value: order } = useContext(OrderStateContext);   
    if ((!order || !order.orderDate) && (!orderData||!orderData.orderDate)) {
        return null;
    }
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderDate">
                {translate("Order Date")}
            </Typography>
            <Typography {...styles.orderDate} aria-labelledby="orderDate">
                <LocalizedDateTime
                    dateTime={order?.orderDate||orderData?.orderDate}
                    options={{ year: "numeric", month: "numeric", day: "numeric" }}
                />
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderDate),
    definition: {
        allowedContexts: [OrderDetailsPageContext,OrderStatusPageContext],
        group: "Order Details",
    },
};

export default widgetModule;